export const parseMeasurement = (value: string): number | null => {
  const normalizedValue = value.replace(",", ".").trim();
  if (!normalizedValue) {
    return null;
  }

  const parsedValue = Number(normalizedValue);
  if (Number.isNaN(parsedValue)) {
    return null;
  }

  return parsedValue;
};

export const formatMeasurement = (value: number | null): string => {
  return value === null ? "" : value.toString();
};
